export type VisualMediaPlayerState = { file?: VisualMediaFile; isPlaying: boolean };

export enum MediaType {
  knowledgeData,
  videoViaDirectFileLink,
  videoViaEmbeddedHtmlPlayer,
}

export type VisualMediaFile = {
  id: string;
  mediaType?: MediaType;
  name: string;
  onCloseRoute?: string;
  splash?: { next?: VideoData; previous?: VideoData };
  url?: string;
  useReactPlayer?: boolean;
};

type VideoData = { image: string; length: string; name: string; url: string };
